export const FULL_MAX_DIMENSION = 1600;
export const THUMB_MAX_DIMENSION = 480;
const JPEG_QUALITY = 0.85;
export const THUMB_QUALITY = 0.8;

export async function compressImage(
  file: File,
  maxDimension: number = FULL_MAX_DIMENSION,
  quality: number = JPEG_QUALITY
): Promise<File> {
  let bitmap: ImageBitmap;
  try {
    bitmap = await createImageBitmap(file);
  } catch (error: unknown) {
    return file;
  }

  const { width, height } = bitmap;
  const scale = Math.min(1, maxDimension / Math.max(width, height));
  const targetWidth = Math.max(1, Math.round(width * scale));
  const targetHeight = Math.max(1, Math.round(height * scale));

  const canvas = document.createElement('canvas');
  canvas.width = targetWidth;
  canvas.height = targetHeight;
  const context = canvas.getContext('2d');
  if (!context) {
    bitmap.close();
    return file;
  }

  context.fillStyle = '#ffffff';
  context.fillRect(0, 0, targetWidth, targetHeight);
  context.drawImage(bitmap, 0, 0, targetWidth, targetHeight);
  bitmap.close();

  const blob = await new Promise<Blob | null>((resolve) =>
    canvas.toBlob(resolve, 'image/jpeg', quality)
  );

  if (!blob || blob.size >= file.size) {
    return file;
  }

  const baseName = file.name.replace(/\.[^.]+$/, '') || 'billede';
  return new File([blob], `${baseName}.jpg`, { type: 'image/jpeg' });
}

export async function readImageDimensions(blob: Blob): Promise<{ width: number; height: number } | null> {
  try {
    const bitmap = await createImageBitmap(blob);
    const dimensions = { width: bitmap.width, height: bitmap.height };
    bitmap.close();
    return dimensions;
  } catch (error: unknown) {
    return null;
  }
}

export function createThumbFileName(fileName: string): string {
  const baseName = fileName.replace(/\.[^.]+$/, '') || 'billede';
  return `${baseName}-thumb.jpg`;
}
